import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DateTime } from 'luxon';
@Pipe({
  name: 'todayTomorrow',
  standalone: false,
})
export class TodayTomorrowPipe implements PipeTransform {
  constructor(
    private readonly date: DatePipe,
    private readonly translateService: TranslateService,
  ) {}
  // eslint-disable-line  no-empty, @typescript-eslint/no-empty-function
  transform(value: string): string {
    try {
      const incommingDate = DateTime.fromISO(value).startOf('day');
      const today = DateTime.now().startOf('day');
      return !incommingDate.isValid
        ? value
        : today.hasSame(incommingDate, 'millisecond')
          ? this.translateService.instant('today')
          : today.plus({ day: 1 }).hasSame(incommingDate, 'millisecond')
            ? this.translateService.instant('tomorrow')
            : this.date.transform(value, 'dd MMM');
    } catch {
      return this.date.transform(value, 'dd MMM');
    }
  }
}
